import { ListVideo } from "lucide-react";

export const CompilerPlaylistGrid = ({ playlists, onSelect }) => {
  if (!playlists.length) {
    return <p data-testid="compiler-no-playlists" className="text-slate-500 text-sm">No playlists found on this channel.</p>;
  }
  return (
    <div data-testid="compiler-playlist-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {playlists.map((pl) => (
        <button
          key={pl.id}
          data-testid="compiler-playlist-card"
          onClick={() => onSelect(pl)}
          className="group text-left bg-slate-900/60 border border-slate-800 rounded-xl overflow-hidden hover:border-indigo-400/50 transition-all"
        >
          <div className="aspect-video bg-slate-950 flex items-center justify-center overflow-hidden">
            {pl.thumbnail ? (
              <img src={pl.thumbnail} alt={pl.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
            ) : (
              <ListVideo className="w-6 h-6 text-slate-700" />
            )}
          </div>
          <div className="p-3">
            <p className="text-sm font-medium text-slate-100 line-clamp-2">{pl.title}</p>
            <p className="text-xs font-mono text-slate-500 mt-1">{pl.video_count} videos</p>
          </div>
        </button>
      ))}
    </div>
  );
};
